import {trackLogs} from "../redux/reducers/loggerSlice";
import {store} from "../redux/store";
import {format} from "date-fns";

const logdatetime = format(new Date(), "MM/dd/yyyy h:mm a");
export const logMessage = (
  level: string,
  message: string,
  pagename: string,
) => {
  try {
    const dispatch = store.dispatch;
    dispatch(
      trackLogs({
        datetime: logdatetime,
        level,
        message,
        pagename,
      }),
    );
  } catch (error) {
    return error;
  }
};
